/* Woof&Crunch delivery date engine.
   Rules come from theme settings, never hardcoded, so Jade can change them herself.
   Two different weeks, deliberately kept apart:
     operatingDays - the days Jade bakes (Mon-Thu)
     postingDays   - the days she can get a parcel into the post (Mon-Fri)
   Conflating them breaks her own stated rule that Monday arrivals are posted on the
   Friday before. Royal Mail does not deliver on Sundays. */
(function () {
  'use strict';

  var CFG = window.WCDeliveryConfig || {};
  var BH_KEY = 'wc-bank-holidays-v1';
  var BH_URL = 'https://www.gov.uk/bank-holidays.json';
  var bankHolidays = new Set((CFG.blackoutDates || []));

  function iso(d) { return d.toISOString().slice(0, 10); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }

  function loadBankHolidays() {
    try {
      var raw = localStorage.getItem(BH_KEY);
      if (raw) {
        var c = JSON.parse(raw);
        if (c.fetched && Date.now() - c.fetched < 30 * 864e5 && Array.isArray(c.dates)) {
          c.dates.forEach(function (d) { bankHolidays.add(d); });
          return Promise.resolve();
        }
      }
    } catch (e) { /* private mode, or storage disabled */ }

    return fetch(BH_URL).then(function (r) { return r.json(); }).then(function (j) {
      var dates = (j['england-and-wales'].events || []).map(function (e) { return e.date; });
      dates.forEach(function (d) { bankHolidays.add(d); });
      try { localStorage.setItem(BH_KEY, JSON.stringify({ fetched: Date.now(), dates: dates })); }
      catch (e) { /* ignore */ }
    }).catch(function () {
      /* Feed unreachable: fall back to the manual override list already in bankHolidays.
         Fail closed is wrong here - it would empty the calendar - so we carry on. */
    });
  }

  function isOperatingDay(d) {
    return CFG.operatingDays.indexOf(d.getDay()) !== -1 && !bankHolidays.has(iso(d));
  }
  function isDeliveryDay(d) {
    // Royal Mail does not deliver Sunday; bank holidays have no delivery either.
    return d.getDay() !== 0 && !bankHolidays.has(iso(d));
  }

  /* Walk forward n operating days from a date. */
  function addOperatingDays(from, n) {
    var d = new Date(from.getTime()), left = n;
    while (left > 0) { d = addDays(d, 1); if (isOperatingDay(d)) left--; }
    return d;
  }

  function isPostingDay(d) {
    return CFG.postingDays.indexOf(d.getDay()) !== -1 && !bankHolidays.has(iso(d));
  }

  /* Latest day Jade can post so the parcel arrives on or before `arrival`.
     For a Monday arrival with 1-day transit this walks back to the Friday, which is
     exactly what Jade already does. */
  function postDayFor(arrival, transitDays) {
    for (var back = transitDays; back <= transitDays + 7; back++) {
      var post = addDays(arrival, -back);
      if (isPostingDay(post)) return post;
    }
    return null;
  }

  function capacityUsed(dateIso) {
    var m = CFG.capacityUsed || {};  // null when the Flow counter isn't set up yet
    return m[dateIso] || 0;
  }

  function earliestDate() {
    var base = CFG.leadTimeBasis === 'operating'
      ? addOperatingDays(new Date(), CFG.leadTimeDays)
      : addDays(new Date(), CFG.leadTimeDays);
    var d = addDays(base, CFG.bufferDays);
    for (var i = 0; i < 400; i++) {
      if (!disabledReason(d)) return d;
      d = addDays(d, 1);
    }
    return d;
  }

  /* Returns null if the date is selectable, otherwise a machine-readable reason. */
  function disabledReason(d) {
    var key = iso(d);
    if (CFG.blackoutDates.indexOf(key) !== -1) return 'blackout';
    if (!isDeliveryDay(d)) return bankHolidays.has(key) ? 'bank-holiday' : 'no-delivery';
    var earliestRaw = CFG.leadTimeBasis === 'operating'
      ? addDays(addOperatingDays(new Date(), CFG.leadTimeDays), CFG.bufferDays)
      : addDays(new Date(), CFG.leadTimeDays + CFG.bufferDays);
    if (d < new Date(iso(earliestRaw))) return 'lead-time';
    if (!postDayFor(d, CFG.transitDays)) return 'no-post-day';
    if (CFG.dailyCap > 0 && capacityUsed(key) >= CFG.dailyCap) return 'at-capacity';
    return null;
  }

  var MESSAGES = {
    'blackout': 'We are closed that week.',
    'bank-holiday': 'That is a bank holiday, so there is no post.',
    'no-delivery': 'Royal Mail does not deliver on Sundays.',
    'lead-time': 'That is too soon for us to bake and post in time.',
    'no-post-day': 'We cannot get a parcel posted in time for that date.',
    'at-capacity': 'That date is fully booked. Please pick another.'
  };

  function format(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function init() {
    var promise = document.querySelector('[data-wc-delivery-promise]');
    if (promise) {
      var e = earliestDate();
      promise.textContent = (promise.hasAttribute('data-wc-short') ? 'Arrives ' : 'Order today, arrives by ') + format(e);
      promise.hidden = false;
    }
    document.querySelectorAll('[data-wc-delivery-date]').forEach(function (input) {
      var e = earliestDate();
      input.min = iso(e);
      var note = document.querySelector('[data-wc-delivery-note]');
      input.addEventListener('change', function () {
        if (!input.value) return;
        var reason = disabledReason(new Date(input.value + 'T12:00:00'));
        if (reason) {
          input.setCustomValidity(MESSAGES[reason]);
          if (note) { note.textContent = MESSAGES[reason]; note.hidden = false; }
        } else {
          input.setCustomValidity('');
          if (note) {
            note.textContent = 'We will post to arrive by ' + format(new Date(input.value + 'T12:00:00')) + '.';
            note.hidden = false;
          }
        }
        input.reportValidity();
      });
    });
  }

  window.WCDelivery = {
    earliestDate: earliestDate,
    isSelectable: function (d) { return disabledReason(d) === null; },
    disabledReason: disabledReason,
    _postDayFor: postDayFor
  };

  loadBankHolidays().then(function () {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  });
})();
